module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product-card', {
    attrs: {
      "product": _vm.product,
      "image": _vm.image,
      "module": _vm.module
    }
  }, [_c('blockquote', {
    staticClass: "l-col-2@md box",
    attrs: {
      "slot": "custom-column"
    },
    slot: "custom-column"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v("Status imagem")]), _vm._v(" "), _c('span', {
    staticClass: "badge hint--left",
    class: _vm.product.imageStatus
  }, [_vm._v(_vm._s(_vm.$t(_vm.product.imageStatus).label))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d5b3f4f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shein/ProductCard.vue
// module id = 3205
// module chunks = 0